module.exports = __webpack_public_path__ + "static/media/n27.e48c2f4a.jpg";